import type { AcademyEventName } from '@app/packages/api/v2/types/misc'

import { createReduxSlice } from '@app/store/redux_slice'

const academyEventDriverSlice = createReduxSlice<{ event: AcademyEventName }>('academy_event_driver')

// The driver carries which academy event the page is showing. Set it (setAcademyEventDriver) in
// fetchData; the courses and lessons-list slices key their loads off it and re-load when it changes.
export const setAcademyEventDriver = (event: AcademyEventName) => academyEventDriverSlice.set({ event })

export const academyEventDriverSelector = academyEventDriverSlice.selector
